<template>
    <div class="ticket-packages-resume-bar">
        <button class="button button-primary" type="button" @click="goToCart">
            {{ trans.resume_bar.checkout }}
        </button>

        <div class="ticket-packages-resume-bar__summary">
            <small>{{ trans.resume_bar.total_items }}: {{ items }}</small>
            <span>{{ trans.resume_bar.total }}: </span>
            <strong>{{ currency }} {{ total }}</strong>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import "../../../../sass/variables";

// Estilos autocontidos (iguais ao riocarnaval-org-laravel): na virada v2 dos
// sites de produção a página ainda carrega o CSS legado de .button, então a
// barra precisa resetar o botão sem depender de .package-details.
.ticket-packages-resume-bar {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 16px;
    display: none;
    justify-content: center;
    align-items: center;
    gap: 16px;
    background-color: $color2-gray-lightest;
    z-index: 100;
    border-top: 1px solid $color2-primary;
    box-sizing: border-box;
    font-family: "Source Sans Pro", "Open Sans", Helvetica, Arial, sans-serif;

    &__summary {
        color: $color2-text-secondary;
        line-height: 1.4;
        text-align: left;
    }

    small {
        display: block;
        font-size: 14px;
        font-weight: 400;
        text-transform: none;
        letter-spacing: 0;
        color: $color2-text-secondary;
    }

    span {
        color: $color2-text-secondary;
        font-size: 14px;
        font-weight: 400;
    }

    strong {
        color: $color2-text-primary;
        font-size: 14px;
        font-weight: 700;
    }

    .button.button-primary {
        display: inline-block;
        position: relative;
        float: none;
        margin: 0;
        min-width: 0;
        width: auto;
        height: auto;
        line-height: 1em;
        padding: 8px 32px;
        font-size: 1rem;
        font-weight: 700;
        font-family: inherit;
        text-align: center;
        text-decoration: none;
        border-radius: 46px;
        border: 2px solid $color2-primary;
        background: $color2-primary;
        color: #ffffff;
        box-shadow: none;
        cursor: pointer;
        appearance: none;
        -webkit-appearance: none;
        transition: all 250ms linear;

        &:hover {
            background: #ffffff;
            color: $color2-primary;
        }

        &:focus {
            outline: none;
            box-shadow: 0 0 5px 2px rgba($color2-primary, 0.5);
        }
    }

    @media (min-width: 800px) {
        display: flex;
    }
}
</style>

<script>
export default {
    props: {
        items: {
            type: Number,
            required: true
        },
        total: {
            type: [String, Number],
            required: true
        },
        currency: {
            type: String,
            required: true
        },
        href: {
            type: String,
            required: true
        },
        trans: {
            type: Object,
            required: true
        }
    },
    methods: {
        goToCart() {
            window.location.href = this.href;
        }
    }
};
</script>
